import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AvantoRestaurantsService } from 'src/app/services/avanto-restaurants.service';
import { ScrollFunctions } from '../../../../util/ScrollFunctions';
import { SessionObject } from 'src/app/avantoeats-util/models/session/SessionObject';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';

@Component({
  selector: 'app-all-categories-sidebar',
  templateUrl: './all-categories-sidebar.component.html',
  styleUrls: ['./all-categories-sidebar.component.scss']
})
export class AllCategoriesSidebarComponent implements OnInit, OnDestroy {
  private sessionObserver: Subscription;
  private selectedMenuSubscription: Subscription;

  categoryTitles: CategoryTitle[];
  isDelivery:boolean;

  constructor(private restaurantsService: AvantoRestaurantsService, private avantoSession:AvantoSessionService) { }

  ngOnInit() {
    this.categoryTitles = [];

    this.selectedMenuSubscription = this.restaurantsService.subject_selectedRestaurant.subscribe(restaurant => {
      this.categoryTitles = [];
      restaurant.categories.forEach(cat => {
        const subcategories = [];

        cat.subCategories.forEach((subCat)=>{
          const subCatDisplayForPickup   = subCat.shouldDisplay!=null?subCat.shouldDisplay.displayForPickup:true;
          const subCatDisplayForDelivery = subCat.shouldDisplay!=null?subCat.shouldDisplay.displayForDelivery:true;
          subcategories.push(new CategoryTitle(subCat.title, subCat.id, [], subCatDisplayForPickup, subCatDisplayForDelivery ));
        })

        const dForPickup   = cat.shouldDisplay!=null?cat.shouldDisplay.displayForPickup:true;
        const dForDelivery = cat.shouldDisplay!=null?cat.shouldDisplay.displayForDelivery:true;
        this.categoryTitles.push(new CategoryTitle(cat.title, cat.id, subcategories, dForPickup, dForDelivery));
      })
    });

    this.sessionObserver = this.avantoSession.sessionSubject.subscribe(session => {
      this.isDelivery = session.orderType == SessionObject.ORDER_TYPE_DELIVERY;
    });
  }

  ngOnDestroy() {
    this.selectedMenuSubscription.unsubscribe();
    this.sessionObserver.unsubscribe();
  }

  /** Scrollls the screen to a specific element, based on it's ID */
  scrollToElement(elementId,isSubCatOffset?) {
    //We are giving a -60px offset because of the bar on the top of the page that is screwing things over
    const offset = isSubCatOffset?-105:-85;
    ScrollFunctions.scrollToId(elementId,offset);
  }
}

//Stores a category title and it's category's ID
//Used for navigation purposes
export class CategoryTitle{
  title:string;
  id:string;
  subCategories:CategoryTitle[]
  displayForPickup:boolean;
  displayForDelivery:boolean;

  constructor(title:string,id:string, subCats:CategoryTitle[], displayForPickup:boolean, displayForDelivery:boolean){
      this.title = title;
      this.id = id;
      this.subCategories = subCats;
      this.displayForPickup = displayForPickup;
      this.displayForDelivery = displayForDelivery;
  }
}